module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "dual_enrollment.f130b82b.png";